import React, { ReactElement } from 'react';

import { makeClassNames } from '../../../utils/styles';
import { isClient, isClientDesktop } from '../../../utils/device-utils';
import { IconCircleLeft, IconCircleRight } from '../../atoms';
import { IIcon } from '../../atoms/icons/icon';
import MatchChange, { IMatchChangeLmp } from '../../molecules/match-change/match-change';
import { HorizontalNav } from '../../molecules/horizontal-nav/horizontal-nav';
import './match-change-lmp.scss';

export interface IMatchChangeLmpTemplate {
  matchId: string; // Current match to SELECT
  matchList: IMatchChangeLmp[];
  trackingData?: object;
}

// ARROWS (DESKTOP only)
const iconLeft = (): ReactElement<IIcon> => <IconCircleLeft size="xsmall" color="light" />;
const iconRight = (): ReactElement<IIcon> => <IconCircleRight size="xsmall" color="light" />;

// ISS-6804 - ERROR BOUNDARY (waiting for BE to FIX mandatory data) + if ONLY 1 MATCH (e.g. the current one in LMP) then do NOT return a GLIDER of MATCHES!
const isValidMatchList = (matchList: IMatchChangeLmp[]) =>
  matchList.length > 1 &&
  matchList.every(
    (match: IMatchChangeLmp) => match.status && match.link && match.home.shortName && match.away.shortName
  );

const transformMatchList = (params: { matchList: IMatchChangeLmp[]; currentUrl: string }) => {
  const { matchList, currentUrl } = params;

  const result = matchList.map((match) => {
    if (currentUrl.match(/\/lmpappsport/)) {
      match.link += '/lmpappsport';
    }

    return {
      ...match,
      link: match.link,
    };
  });

  return result;
};

const classNames = () =>
  makeClassNames({
    wrapper: 'match-change-lmp__wrapper',
    item: 'match-change-lmp__item',
    arrowLeft: 'match-change-lmp__arrow-left',
    arrowRight: 'match-change-lmp__arrow-right',
  });

const MatchChangeLmp = ({
  /* istanbul ignore next: default value */ matchList = [],
  matchId,
  trackingData,
}: IMatchChangeLmpTemplate) => {
  const cn = classNames();
  const transformedMatchList = !isClient() ? matchList : transformMatchList({ matchList, currentUrl: location.href });
  const activeSlideIndex: number = transformedMatchList.findIndex((match: IMatchChangeLmp) => match.id === matchId);

  return isValidMatchList(matchList) ? (
    <div className={cn.wrapper}>
      <HorizontalNav
        activeIndex={activeSlideIndex}
        arrows={{
          show: isClientDesktop,
          width: 120,
          left: { icon: iconLeft(), className: cn.arrowLeft },
          right: { icon: iconRight(), className: cn.arrowRight },
        }}
      >
        {matchList.map((match, index) => (
          <HorizontalNav.Item key={index} index={index} className={cn.item} hasInnerLink>
            <MatchChange {...match} variant="lmp" trackingData={trackingData} isSelected={activeSlideIndex === index} />
          </HorizontalNav.Item>
        ))}
      </HorizontalNav>
    </div>
  ) : null;
};

export default MatchChangeLmp;
